import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import groceriesImg from '../images/groceriesimg.jpg';
import { Link } from 'react-router-dom';

const GroceryPage = () => {
  return (
    <div className="container my-5">
      <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
        <div className="row g-0">
          {/* Left Image */}
          <div className="col-md-6">
            <img
              src={groceriesImg}
              alt="Groceries"
              className="img-fluid h-100"
              style={{ objectFit: 'cover' }}
            />
          </div>

          {/* Right Content */}
          <div className="col-md-6 d-flex flex-column justify-content-center p-4 p-md-5 bg-light">
            <h2 className="mb-3 fw-bold text-success">Shakambari E-Commerce Groceries</h2>
            <p className="mb-3 text-muted" style={{ lineHeight: 1.7 }}>
              Welcome to <strong>Shakambari</strong>, your trusted online store for fresh, premium-quality groceries. We bring the farm to your doorstep — with a wide range of essential products, daily staples, and organic items that are handpicked for purity and freshness.
            </p>
            <ul className="mb-4 ps-3">
              <li>✅ 100% Quality Assured Products</li>
              <li>✅ Daily Fresh Vegetables & Fruits</li>
              <li>✅ Essential Staples – Rice, Pulses, Oil, Flour</li>
              <li>✅ Packaged Food, Spices & More</li>
              <li>✅ Fast & Hygienic Delivery</li>
              <li>✅ Easy Returns & 24/7 Customer Support</li>
            </ul>
            <h5 className="fw-semibold">Groceries that care for your family’s health.</h5>
            <p className="text-muted mt-2">
              Experience convenience, affordability, and unmatched quality with Shakambari E-Commerce. Start shopping today!
            </p>
            <Link
              to="/product"
              className="btn btn-success fw-semibold mt-3 px-4 py-2 rounded-pill"
            >
              Explore Products
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroceryPage;
